<script lang="ts">
  import { onMount, untrack } from "svelte"
  import { fromStore } from "svelte/store"
  import type { ContextSessionResponse } from "@kontextwerk/control-web-client"
  import type { createContextRootClient } from "@kontextwerk/control-web-frame/shared/logic/context-runtime"
  import { isSameConfirmedSessionBinding } from "../../../../../../../_shared/_logic/auth-context"
  import { createContextPlanning } from "./_logic/contextPlanning"
  import PlanningSettingsForm from "../planning-settings-form"
  let {
    client,
    session,
    organizationId,
  }: {
    client: ReturnType<typeof createContextRootClient>
    session: ContextSessionResponse
    organizationId: string
  } = $props()
  const binding = untrack(() => ({ client, session, organizationId }))
  const controller = createContextPlanning(binding.client, binding.session, binding.organizationId)
  const view = fromStore(controller.state)
  // effect-ok: security invalidation aborts the old owner's requests and destroys its draft.
  $effect(() => {
    if (
      client !== binding.client ||
      !isSameConfirmedSessionBinding(session, binding.session) ||
      organizationId !== binding.organizationId
    )
      controller.dispose()
  })
  onMount(() => {
    void controller.load()

    return () => controller.dispose()
  })
</script>

<section aria-label="Terminplanung">
  {#if view.current.status === "denied" || view.current.status === "invalidated"}
    <p role="status">Zugang zur Terminplanung nicht bestaetigt.</p>
  {:else if view.current.status === "error"}
    <p role="alert">Termineinstellungen konnten nicht geladen werden.</p>
    <button onclick={() => controller.load()}>Erneut laden</button>
  {:else if view.current.settings}
    <PlanningSettingsForm
      organizationId={binding.organizationId}
      settings={view.current.settings}
      canManage={controller.canManage}
      saveSettings={controller.save}
      onSettingsUpdated={() => {}}
    />
  {:else}<p role="status">Termineinstellungen werden geladen.</p>{/if}
</section>
